import React from 'react';
import {
  AboutContainer,
  FounderSection,
  FounderCopy,
  FounderIntro,
} from './About.styles';
import Industries from './Industries/Industries.component';
import Stats from './Stats/Stats.component';
import Values from './Values/Values.component';
// import PageHeader from '../../../Components/PageHeader/PageHeader.component';
import Achievements from './Achivements/Achievements.component';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';

const About = () => {
  return (
    <AboutContainer>
      <BreadCrumbs one="Home" onelink="/" two="About Us" />
      {/* <PageHeader
        title="Our Story & Leadership"
        eyebrow="About Us"
        desc="Practical safety support built on experience, trust, and real-world knowledge."
      /> */}

      <FounderSection>
        <FounderIntro>
          <span>Founder / Owner</span>
          <h3>Jim Benoit</h3>
          <p className="founderTitle">
            {' '}
            President/CEO of Yoda Safety Services Inc.
          </p>
        </FounderIntro>

        <FounderCopy>
          <p>
            Jim owned Occupational Health & Educational Services from 2001 to
            2023 a register Safety Certified Provider with the Workers
            Compensation Board of Nova Scotia. Jim has started a new Business in
            August 2023 called Yoda Safety Services Inc and has become a new
            Safety Certified Provider with the Workers Compensation Board of
            Nova Scotia as of June 2024.
          </p>

          <p>
            His ideals and philosophy remain the same in providing customer
            service, quality, dependability, pricing, etc., is on going. Jim
            believes the success of any business is having satisfied clients. An
            open door policy with clients and staff is essential, this is a
            policy that most companies build their foundation of success on.
          </p>
        </FounderCopy>
      </FounderSection>
      <Stats />
      <Industries />
      <Values />
      <Achievements />
    </AboutContainer>
  );
};

export default About;
